import { router } from "@inertiajs/react"
import { STATUS_CONFIG } from "@/lib/project-configs"
import type { Project, PipeStatusRecord, ProjectStatus } from "@/types"

type Props = {
  project: Project
  pipeStatuses: PipeStatusRecord[]
  onSelect?: () => void
}

const DISPLAY_GROUPS: ProjectStatus[] = ["pending", "accepted", "rejected", "asset", "archived"]

export function PipeStatusPopoverContent({ project, pipeStatuses, onSelect }: Props) {
  const byParentStatus: Record<string, PipeStatusRecord[]> = {}
  for (const ps of pipeStatuses) {
    if (!byParentStatus[ps.parent_status]) byParentStatus[ps.parent_status] = []
    byParentStatus[ps.parent_status].push(ps)
  }

  const handleSelect = (ps: PipeStatusRecord) => {
    if (ps.id !== project.pipe_status_id) {
      router.patch(`/projects/${project.id}/update_pipe_status`, { pipe_status_id: ps.id }, { preserveScroll: true })
    }
    onSelect?.()
  }

  return (
    <div>
      {DISPLAY_GROUPS.map((status) => {
        const pipes = byParentStatus[status] || []
        if (pipes.length === 0) return null
        return (
          <div key={status} className="mb-1">
            <p className="text-muted-foreground px-2 py-1 text-xs font-medium">{STATUS_CONFIG[status].label}</p>
            {pipes.map((ps) => {
              const isActive = ps.id === project.pipe_status_id
              return (
                <button
                  key={ps.id}
                  onClick={() => handleSelect(ps)}
                  className={`flex w-full cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 transition-colors hover:bg-accent ${isActive ? "bg-accent" : ""}`}
                >
                  <span
                    className="inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium"
                    style={{ backgroundColor: ps.bg_color, color: ps.text_color }}
                  >
                    {ps.label}
                  </span>
                </button>
              )
            })}
          </div>
        )
      })}
    </div>
  )
}
